import { useTranslation } from 'react-i18next'
import type { GroupBase } from 'react-select'

import Select, { type SelectOption } from '@/components/Select/Select'
import useClassesOptions from '@/queries/useClassesOptions'
import type { FormFieldType } from '@/types/form-field-type'

const PreferredClassesSelect = (
  props: FormFieldType<SelectOption<string>[]>
) => {
  const { t } = useTranslation('rooms')

  const { data: classes, isLoading: isClassesLoading } = useClassesOptions()

  const optionsData = (classes ?? []).map(({ name, id, preferredRoom }) => ({
    label: name,
    value: id,
    hasPreferredRoom: !!preferredRoom
  }))

  const options: GroupBase<SelectOption<string>>[] = [
    {
      label: t('label.with-preferred-room'),
      options: optionsData.filter(opt => opt.hasPreferredRoom)
    },
    {
      label: t('label.without-preferred-room'),
      options: optionsData.filter(opt => !opt.hasPreferredRoom)
    }
  ].map(group => ({
    ...group,
    options: group.options.map(({ label, value }) => ({ label, value }))
  }))

  return (
    <Select<string>
      {...props}
      multiple
      mode="detailed"
      loading={isClassesLoading}
      placeholder={t('placeholder.select-class')}
      options={options}
    />
  )
}

export default PreferredClassesSelect
